// React & Router
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import withRouter from '../withRouter'; // HOC สำหรับใช้งานกับ Router

// Axios
import axios from 'axios';

// sweetalert2
import Swal from 'sweetalert2'

// Bootstrap Components
import {
    Container,
    Row,
    Col,
    Image
} from 'react-bootstrap';

// RSuite Components
import {
    Navbar,
    Nav,
    Panel,
    MaskedInput,
    Button,
    HStack,
    Loader
} from 'rsuite';

// Captcha
import ReCAPTCHA from 'react-google-recaptcha';

import Logo from '../../images/logo512.png';

class ResultsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: null,
            modal: null,
            loading: false,
            isMobile: window.innerWidth <= 768,
            idCard: '',
            result: null,
            captchaValue: null
        };
        this.recaptchaRef = React.createRef();
    }

    componentDidMount() {

        window.addEventListener('resize', this.handleResize);

        this.setState({ loading: true }, async () => {
            await this.onRenderContent({ mode: 'read' });
            this.setState({ loading: false });
        });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        const isMobileNow = window.innerWidth <= 768;
        if (isMobileNow !== this.state.isMobile) {
            this.setState({ isMobile: isMobileNow }, () => {
                this.onRenderContent({ mode: 'read' });
            });
        }
    };

    promisedSetState = newState => {
        return new Promise(resolve => this.setState(newState, resolve));
    };

    onRenderContent = async ({ mode }) => {
        if (mode === 'read') {
            const { isMobile, idCard, result } = this.state;
            const fontScale = isMobile ? 1.1 : 1.5;

            const content = (
                <Container
                    fluid="md"
                    style={{
                        padding: '1rem',
                        maxWidth: '960px',
                        margin: '0 auto',
                        borderRadius: '1rem'
                    }}
                >
                    {/* Navbar */}
                    <Navbar
                        className="shadow-sm mb-4"
                        style={{
                            backgroundColor: '#8a0a0a',
                            borderRadius: '1rem',
                            color: 'white',
                            justifyContent: 'center'
                        }}
                    >
                        <Nav>
                            <HStack style={{ alignItems: 'center', gap: '0.5rem' }}>
                                <Image
                                    src={Logo}
                                    rounded
                                    style={{
                                        width: isMobile ? '50px' : '70px',
                                        height: 'auto',
                                        padding: '0.25em'
                                    }}
                                />
                                <span style={{ fontSize: `${1.1 * fontScale}rem`, textAlign: 'center' }}>
                                    ทุนการศึกษามูลนิธิแม่ฟ้าหลวง ในพระบรมราชูปถัมภ์
                                </span>
                            </HStack>
                        </Nav>
                    </Navbar>

                    {/* Main Panel */}
                    <Panel
                        header={
                            <h2
                                style={{
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                    fontSize: `${1.4 * fontScale}rem`
                                }}
                            >
                                ประกาศผลการคัดเลือกทุนการศึกษา
                            </h2>
                        }
                        bordered
                        className="shadow-sm"
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '1rem',
                            padding: isMobile ? '1.2rem' : '2rem'
                        }}
                    >
                        {/* Subtitle */}
                        <Row className="mb-4">
                            <Col>
                                <h2
                                    style={{
                                        textAlign: 'center',
                                        fontWeight: '500',
                                        fontSize: `${1.2 * fontScale}rem`
                                    }}
                                >
                                    การพิจารณาคัดเลือกรับทุนการศึกษามูลนิธิแม่ฟ้าหลวง ในพระบรมราชูปถัมภ์ ประจำปี {this.props.params.year}
                                </h2>
                            </Col>
                        </Row>

                        {/* Input Field */}
                        <Row className="mb-4 align-items-center">
                            <Col
                                xs={12}
                                md={5}
                                className="text-md-end text-center mb-2 mb-md-0"
                            >
                                <label
                                    htmlFor="idCardInput"
                                    style={{
                                        fontWeight: 'bold',
                                        fontSize: `${1.2 * fontScale}rem`
                                    }}
                                >
                                    โปรดระบุเลขประจำตัวประชาชน :
                                </label>
                            </Col>
                            <Col xs={12} md={7}>
                                <MaskedInput
                                    id="idCardInput"
                                    className="pQv92"
                                    size="lg"
                                    value={this.state.idCard}
                                    onChange={value => this.setState({ idCard: value, result: null })}
                                    mask={[
                                        /[0-9,Gg]/,
                                        '-',
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        '-',
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        '-',
                                        /\d/,
                                        /\d/,
                                        '-',
                                        /\d/
                                    ]}
                                    guide={false}
                                    showMask={[
                                        /[0-9,Gg]/,
                                        '-',
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        '-',
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        '-',
                                        /\d/,
                                        /\d/,
                                        '-',
                                        /\d/
                                    ]}
                                    keepCharPositions={true}
                                    style={{
                                        fontSize: `${1.2 * fontScale}rem`,
                                        width: '100%',
                                        padding: isMobile ? '0.6rem' : '0.6rem',
                                        letterSpacing: '0.1em'
                                    }}
                                    placeholderChar="_"
                                />
                            </Col>
                        </Row>

                        {/* Captcha */}
                        <Row className="mb-4 justify-content-center">
                            <Col xs="auto" style={{ textAlign: 'center', display: 'inline-block' }}>
                                <ReCAPTCHA
                                    ref={this.recaptchaRef}
                                    sitekey={process.env.REACT_APP_RECAPTCHA}
                                    onChange={value => this.setState({ captchaValue: value })}
                                />
                            </Col>
                        </Row>

                        {/* Result Display */}
                        {result && (
                            <Row className="justify-content-center mt-4 mb-4">
                                <Col xs={12} md={8} style={{ textAlign: 'center' }}>
                                    <span
                                        style={{
                                            fontSize: `${2 * fontScale}rem`,
                                            fontWeight: 'bold',
                                            color: result === 'pass' ? 'green' : 'red',
                                            userSelect: 'none'
                                        }}
                                    >
                                        {result === 'pass'
                                            ? 'คุณได้รับการคัดเลือก'
                                            : 'คุณไม่ผ่านการคัดเลือก'}
                                    </span>
                                </Col>
                            </Row>
                        )}

                        {/* Button */}
                        <Row className="justify-content-center">
                            <Col xs={12} md={6}>
                                <Button
                                    startIcon={<i className="bi bi-search"></i>}
                                    appearance="primary"
                                    color="blue"
                                    style={{
                                        width: '100%',
                                        maxWidth: '300px',
                                        padding: isMobile ? '0.4em 0.6em' : '0.6em 0.8em',
                                        margin: '0 auto',
                                        display: 'block',
                                        fontSize: `${1.0 * fontScale}rem`
                                    }}
                                    onClick={this.handleSearch}
                                >
                                    ค้นหา
                                </Button>
                            </Col>
                        </Row>
                    </Panel>
                </Container>
            );

            await this.promisedSetState({ content });
        }
    };

    handleSearch = async () => {
        const { idCard, captchaValue } = this.state;

        // ตรวจสอบ captcha
        if (!captchaValue) {
            Swal.fire({
                icon: 'warning',
                title: 'กรุณายืนยันว่าไม่ใช่บอท',
                confirmButtonText: 'ตกลง'
            });
            return; // หยุดฟังก์ชันถ้า captcha ยังไม่ผ่าน
        }

        // ลบขีดและ underscore
        const cleanedId = idCard.replace(/[-_]/g, '').trim();

        if (cleanedId.length !== 13) {
            Swal.fire({
                icon: 'warning',
                title: 'กรุณากรอกเลขประจำตัวประชาชนให้ครบ 13 หลัก',
                confirmButtonText: 'ตกลง'
            });
            return;
        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_API}/application/decision`, {
                id_card_number: cleanedId,
                year: this.props.params.year,
                captcha_token: captchaValue // ส่ง token ไป server ตรวจสอบ
            });

            const { decision_result } = response.data;

            this.setState({ result: decision_result ? 'pass' : 'fail' }, () =>
                this.onRenderContent({ mode: 'read' })
            );
        } catch (error) {
            const message = error.response?.data?.message || 'เกิดข้อผิดพลาดในการตรวจสอบข้อมูล';
            Swal.fire({
                icon: 'error',
                title: message,
                confirmButtonText: 'ตกลง'
            });
        }
    };

    render() {
        const FullPageLoader = () => (
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999
                }}
            >
                <Loader content="Loading..." />
            </div>
        );

        return (
            <>
                {this.state.content}
                {this.state.modal}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}

export default withRouter(ResultsPage);